import React from 'react';

export const OfflineFallback: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-background text-text-primary p-4">
            <span className="material-symbols-outlined text-6xl text-primary mb-4 opacity-80">
                wifi_off
            </span>
            <h1 className="text-2xl font-bold mb-2 text-center">Vous êtes hors ligne</h1>
            <p className="text-text-secondary text-center mb-6 max-w-sm">
                Padel Brothers nécessite une connexion internet pour la plupart de ses fonctionnalités. Veuillez vérifier votre connexion.
            </p>
            <button
                onClick={() => window.location.reload()}
                className="bg-primary text-white p-3 rounded-lg font-bold w-full max-w-xs shadow-lg hover:bg-primary-hover active:bg-primary-active transition-colors"
            >
                Réessayer
            </button>
        </div>
    );
};
